import React from "react";
import { FaPhoneAlt, FaEnvelope, FaGlobe } from "react-icons/fa";

const toPersianDigits = (num) =>
  num.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

const Footer = () => {
  return (
  <footer
   dir="rtl"
  className="bg-white/25  border-t border-white/40 text-sm text-blue-900 shadow-inner w-full rounded-lg sm:block">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-3 py-3">
      {/* ✅ سمت راست: اطلاعات تماس (راست‌چین کامل و زیر هم) */}
      <div className="flex flex-col items-end text-right space-y-1 order-1 sm:order-2">
        <div className="flex flex-row-reverse items-center gap-2">
          <FaPhoneAlt className="text-blue-700" />
          <span>{toPersianDigits("011-44203690-3")}</span>
        </div>

        <div className="flex flex-row-reverse items-center gap-2">
          <FaEnvelope className="text-blue-700" />
          <a
            href="mailto:Info@harazdairy.com"
            className="text-blue-700 hover:underline"
          >
            Info@doosheh.com
          </a>
        </div>

        <div className="flex flex-row-reverse items-center gap-2">
          <FaGlobe className="text-blue-700" />
          <a
            href="https://doosheh.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-700 hover:underline"
          >
            doosheh.com
          </a>
        </div>
      </div>

      {/* ✅ سمت چپ: نماد اعتماد و درگاه پرداخت */}
      <div
        className="flex items-center gap-4 order-2 sm:order-1"
        dangerouslySetInnerHTML={{
          __html: `
    <a referrerpolicy="origin" target="_blank"
       href="https://trustseal.enamad.ir/?id=673687&Code=jO9oeycUA2pku5WyQHqaov5V1I5UHK0b">
      <img referrerpolicy="origin"
           src="https://trustseal.enamad.ir/logo.aspx?id=673687&Code=jO9oeycUA2pku5WyQHqaov5V1I5UHK0b"
           alt=""
           style="cursor:pointer"
           code="jO9oeycUA2pku5WyQHqaov5V1I5UHK0b" />
    </a>
  `,
        }}
      />
    </div>

    {/* ✅ کپی‌رایت وسط پایین */}
    <div className="text-center text-gray-600 border-t pt-2 pb-2 text-xs">
      © {new Date().getFullYear()} تمامی حقوق سایت متعلق به شرکت دوشه (هراز)
      می‌باشد.
    </div>
  </footer>
   );
};
//   return (
//     <footer
//       dir="rtl"
//       className="bg-white border-t text-sm text-blue-900 shadow-inner w-full rounded-lg sm:block"
//     >
//       <div className="px-4 py-3 flex flex-col gap-3">
//         {/* سمت راست — اطلاعات تماس */}
//         <div className="flex flex-row items-center gap-4">
//           <div className="flex flex-row-reverse items-center gap-1">
//             <FaPhoneAlt className="text-blue-700" />
//             <span>{toPersianDigits("011-44203690-3")}</span>
//           </div>

//           <div className="flex flex-row-reverse items-center gap-1">
//             <FaEnvelope className="text-blue-700" />
//             <a
//               href="mailto:Info@doosheh.com"
//               className="text-blue-700 hover:underline"
//             >
//               Info@doosheh.com
//             </a>
//           </div>

//           <div className="flex flex-row-reverse items-center gap-1">
//             <FaGlobe className="text-blue-700" />
//             <a
//               href="https://doosheh.com/"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-blue-700 hover:underline"
//             >
//               doosheh.com
//             </a>
//           </div>
//         </div>
//         {/* نماد اعتماد — سر جایش */}
//         <div
//           className="flex items-center gap-3 order-2 sm:order-1"
//           dangerouslySetInnerHTML={{
//             __html: `
//     <a referrerpolicy="origin" target="_blank"
//        href="https://trustseal.enamad.ir/?id=673687&Code=jO9oeycUA2pku5WyQHqaov5V1I5UHK0b">
//       <img referrerpolicy="origin"
//            src="https://trustseal.enamad.ir/logo.aspx?id=673687&Code=jO9oeycUA2pku5WyQHqaov5V1I5UHK0b"
//            alt=""
//            style="cursor:pointer"
//            code="jO9oeycUA2pku5WyQHqaov5V1I5UHK0b" />
//     </a>
//   `,
//           }}
//         />
//       </div>

//       {/* کپی‌رایت */}
//       <div className="text-center text-gray-600 border-t pt-2 pb-2 text-xs">
//         © {new Date().getFullYear()} تمامی حقوق سایت متعلق به شرکت دوشه (هراز)
//         می‌باشد.
//       </div>
//     </footer>
//   );
// };

export default Footer;
